const TOKEN_KEY = 'mh_app_token';

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string | null): void {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function clearToken(): void {
  setToken(null);
}

export function notifyAuthChanged(): void {
  window.dispatchEvent(new CustomEvent('mh-auth-changed'));
}
